import React, { useRef, useState, useEffect } from 'react';
import { useApp } from '../../context/AppContext';
import { useSimulado } from '../../context/SimuladoContext';
import { useReactToPrint } from 'react-to-print';
import Sidebar from '../../components/base/Sidebar/Sidebar';
import './LocalDeProva.css';
import logoSrc from '../../assets/230616_RV_logo_restrito_negativo-branco.png'
import logoColorSrc from '../../assets/230616_RV_logo_principal_positivo-cor.png'

function LocalDeProva() {
  const { user } = useApp();
  const { simulado } = useSimulado();
  const cartaoRef = useRef(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Formata CPF como xxx.xxx.xxx-xx
  const formatCPF = (cpf) => {
    if (!cpf) return '';
    // Remove characteres não numéricos
    const cleaned = cpf.replace(/\D/g, '');
    // Format como xxx.xxx.xxx-xx
    return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        const userID = user?.ID_usuario;
        const selectedSimuladoID = simulado.id;
        
        if (!userID || !selectedSimuladoID) {
          throw new Error('User ID or Exam ID not found in localStorage');
        }

        const response = await fetch(
          `https://rvensino.com.br/get.php?action=exam_confirmation_card_info&user_id=${userID}&exam_id=${selectedSimuladoID}`
        );

        
        if (!response.ok) {
          throw new Error('Failed to fetch data from API');
        }
        
        const jsonData = await response.json();
        setData(jsonData);

        console.log(jsonData)

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

    const handlePrint = useReactToPrint({
    contentRef: cartaoRef,
    pageStyle: `
      @page {
        size: A4 portrait;
        margin: 0.5cm; /* smaller margin but still safe */
      }

      @media print {
        body {
          margin: 0 !important;
          padding: 0 !important;
          background: white !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          color-adjust: exact !important;
        }

        .cartao-confirmacao-container {
          background: white;
          box-shadow: none !important;
          transform: scale(0.78); /* zoom in/out */
          transform-origin: top center;
          page-break-inside: avoid;
          width: 125%;
          margin: 0 auto !important;
          margin-left: -12% !important;
        }

        .footer button.exam.details.confirmacao {
          display: none !important;
        }

        /* Compact spacing for single-page print */

        .dados-pessoais {
          gap: 5px 20px !important;
          padding: 3px 10px !important;
        }

        .tabela-container {
          margin-top: 5px !important;
        }

        .tabela-container table {
          font-size: 0.7rem !important;
          margin-bottom: 4px !important;
        }

        .tabela-container th,
        .tabela-container td {
          padding: 3px 4px !important;
        }

        .tabela-container h4,
        .locais-prova h4,
        .instrucoes-container h4,
        .dados-pessoais-container h4 {
          padding: 5px 0 !important;
          font-size: 0.9rem !important;
        }

        .instrucoes-lista {
          font-size: 0.75rem !important;
          line-height: 1.25 !important;
        }

        .documentos-identificacao {
          font-size: 0.7rem !important;
          padding: 5px 15px !important;
        }

        .document-rules {
          font-size: 0.65rem !important;
        }

        .footer-rv-img img {
          height: 50px !important;
        }
      }
    `,
    documentTitle: 'Cartão de Confirmação - ENEM',
  });



  if (loading) {
    return (
      <div className='page-container'>
        <div className='menu'>
          <Sidebar />
        </div>
        <div className='content'>
          <div className="loading-container">
            <p>Carregando dados do cartão de confirmação...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='page-container'>
        <div className='menu'>
          <Sidebar />
        </div>
        <div className='content'>
          <div className="error-container">
            <p>Erro ao carregar dados: {error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className='page-container'>
        <div className='menu'>
          <Sidebar />
        </div>
        <div className='content'>
          <div className="error-container">
            <p>Nenhum dado disponível</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='page-container'>
      <div className='menu'>
        <Sidebar />
      </div>
      <div className='content'>
        
        <div className="cartao-confirmacao-container" ref={cartaoRef}>
      <header className="header">
        <div className="logo-placeholder">
          {logoSrc && <img src={logoSrc} alt="Logo" />}
        </div>
        <div className="titulo-container">
          
          <div className="cartao-titulo">CARTÃO DE CONFIRMAÇÃO</div>
          
          <div className='titulo-divider'></div>

          <div className='enem-titulo-container'>
            <div className='enem-simulado'>SIMULADO</div> 
            <div className="enem-titulo"><span className='enem-titulo-bold'>enem</span><span className='enem-year'>2026</span></div>
            <div className="enem-subtitulo">Exame Nacional do Ensino Médio</div>
          </div>

        </div>
      </header>

      <div className='simulado-name-container'>
          <div className='simulado-name'>{data.simulado_completo}</div>
      </div>

      <div className="dados-pessoais-container">
        <h4>DADOS DO PARTICIPANTE</h4>
        <div className="dados-pessoais">
          
          <div>
            <div className="campo">
              <p>NOME COMPLETO:</p>
              <span>{data.nome_completo}</span>
            </div>
            <div className="campo">
              <p>NÚMERO DO CPF:</p>
              <span>{formatCPF(data.numero_cpf)}</span>
            </div>
          </div>

          <div>
            <div className="campo">
              <p>NÚMERO DE INSCRIÇÃO:</p>
              <span>{data.numero_matricula}</span>
            </div>
            <div className="campo">
              <p>LÍNGUA ESTRANGEIRA:</p>
              {/* <span>{data.lingua_estrangeira}</span> */}
              <span>{data.simulado_type === 'ENEM GERAL' ? 'INGLÊS / ESPANHOL' : '-'}</span>
            </div>
          </div>


        </div>
      </div>

      

      <div className="tabela-container">
        <h4>DATAS E HORÁRIOS DAS PROVAS | <span className='h4-regular'>HORÁRIO OFICIAL DE BRASÍLIA/DF</span></h4>
        <table>
          <thead>
            <tr>
              <th className='empty-th'></th>
              <th className='empty-th'></th>
              <th>DATA DAS PROVAS</th>
              <th>ABERTURA DOS PORTÕES</th>
              <th>FECHAMENTO DOS PORTÕES</th>
              <th>INÍCIO DAS PROVAS</th>
              <th className='last-th'>TÉRMINO DAS PROVAS</th>
            </tr>
          </thead>
          <tbody>
            {data.simulado_type === 'ENEM GERAL' ? (
              data.provas.map((prova, index) => (
                <tr key={index} className={index === 0 ? 'border-top' : ''}>
                  <td className='dia'>{prova.dia}</td>
                  <td>{prova.descricao}</td>
                  <td className='border-portao'>{prova.data_provas}</td>
                  {index === 0 && (
                    <>
                      <td rowSpan={data.provas.length} className='portao'>{data.abertura_portoes}</td>
                      <td rowSpan={data.provas.length} className='portao'>{data.fechamento_portoes}</td>
                    </>
                  )}
                  <td>{prova.inicio_provas}</td>
                  <td>{prova.fim_provas}</td>
                </tr>
              ))
            ) : (
              <>
                <tr className='border-top'>
                  <td className='dia'>1º DIA</td>
                  <td>Linguagens, Códigos e suas Tecnologias, Redação e Ciências Humanas e suas Tecnologias</td>
                  <td className='border-portao'>-</td>
                  <td rowSpan={2} className='portao'>{data.abertura_portoes}</td>
                  <td rowSpan={2} className='portao'>{data.fechamento_portoes}</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td className='dia'>2º DIA</td>
                  <td>Ciências da Natureza e suas Tecnologias e Matemática e suas Tecnologias</td>
                  <td className='border-portao'>{data.provas[0].data_provas}</td>
                  <td>{data.provas[0].inicio_provas}</td>
                  <td>{data.provas[0].fim_provas}</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>

      <section className="locais-prova">
        <h4>LOCAL DAS PROVAS</h4>
        <div className="locais-content">
          <div className="locais-left">
            <div className='local'>
              <label>LOCAL DE REALIZAÇÃO DO EXAME:</label>
              <span>{data.local_exame.local}</span>
            </div>
            <div className="endereco">
                <label>ENDEREÇO DE REALIZAÇÃO DO EXAME:</label>
                <span>{data.local_exame.endereco}</span>
            </div>
            <div className="cidade">
                <label>CIDADE/UF DE REALIZAÇÃO DO EXAME:</label>
                <span>{data.local_exame.cidade}</span>
            </div>
          </div>
          <div className='sala'>
            <label>SALA</label>
            <span>{data.local_exame.numero_sala}</span>
          </div>
        </div>
      </section>

      <section className="instrucoes-container">
        <h4>INSTRUÇÕES</h4>
        <div className="instrucoes-lista">
          <p><span>Atenção!</span></p>
          <ul>
            <li>Realize a impressão da Declaração Comparecimento e apresente ao chefe de sala, antes de entrar na sala de provas, por dia, se precisar.</li>
            <li>Por questões de segurança, o Boletim de Ocorrências não será aceito como documento de identificação.</li>
            <li>Você poderá levar lanches para a sala de provas, no entanto, eles serão vistoriados pelo chefe de sala.</li>
          </ul>
        </div>
      </section>

      <section className="documentos-identificacao">
        <div className='documentos-text-container'>
          <h4>Documentos válidos para realização do Exame:</h4>
          <p>Para identificação do participante brasileiro:</p>
          <ul>
            <li>Cédulas de Identidade expedidas por Secretarias de Segurança Pública, Forças Armadas, Polícia Militar e Polícia Federal;</li>
            <li>Identidade fornecida por ordens ou conselhos de classes que, por lei, tenha validade como documento de identidade;</li>
            <li>Passaporte;</li>
            <li>Carteira Nacional de Habilitação, na forma da Lei nº 9.503, de 23 de setembro de 1997;</li>
            <li>Carteira de Trabalho e Previdência Social impressa e expedida após 27 de janeiro de 1997;</li>
            <li>Documentos digitais com foto (e-Título, CNH Digital, RG Digital e CIN digital) apresentados nos respectivos aplicativos oficiais ou no aplicativo Gov.br</li>
          </ul>
          <p>Para identificação do participante estrangeiro:</p>
          <ul>
            <li>Passaporte;</li>
            <li>Identidade expedida pelo Ministério da Justiça para estrangeiros, inclusive aqueles reconhecidos como refugiados, em concordância com a Lei nº 9.474, de 22 de julho de 1997;</li>
            <li>Carteira de Registro Nacional Migratório, de que trata a Portaria nº 11.264, de 24 de janeiro de 2020;</li>
            <li>Documento provisório de Registro Nacional Migratório, de que trata a Portaria nº 11.264, de 24 de janeiro de 2020;</li>
            <li>Cédula de identidade civil ou documento estrangeiro equivalente, emitido por Estado parte ou associado ao Mercosul, nos termos do Acordo sobre Documentos de Viagem dos Estados Partes do Mercosul e Estados Associados.</li>
          </ul>
        </div>
        <div>
          <h4>Lembre-se de:</h4>
          <ul>
            <li>Comparecer ao local com antecedência de 1(uma) hora do fechamento dos portões.</li>
            <li>Levar caneta esferográfica de tinta preta fabricada em material transparente.</li>
            <li>Não portar fora do envelope porta-objetos fornecido pelo chefe de sala, ao ingressar na sala de provas: Declaração de Comparecimento impressa, Cartão de Confirmação da Inscrição, bulas, óculos escuros e artigos de chapelaria, como boné, chapéu, viseira, gorro ou similares, caneta de material não transparente, lápis, lapiseira, borracha, régua, corretivo, livros, manuais, impressos, anotações, protetor auricular, relógio de qualquer tipo e quaisquer dispositivos eletrônicos, como garrafa/copo digital, cigarro eletrônico, telefone celular, smartphone, tablet, wearable tech, máquina calculadora, agenda eletrônica e/ou similates, Ipod, gravador, pen drive, mp3 e/ou similar, alarme, chave com alarme ou com qualquer outro componente eletrônico, fone de ouvido e/ou qualquer transmissor, gravador e/ou receptor de dados, imagens, vídeos e mensagens, assim como quaisquer outros materiais estranhos à realização da prova;</li>
            <li>Não utilizar, ao ingressar na sala de provas, óculos escuros e artigos de chapelaria, como: boné, chapéu, viseira, gorro ou similares, durante a realização das provas;</li>
            <li>Que se o seu celular ou qualquer equipamento eletrônico tocar, depois do fechamento dos portões, mesmo dentro do envelope porta-objetos, você será eliminado.</li>
            <li>Conferir o seu local de provas com antecedência;</li>
            <li>Imprimir seu Cartão de Confirmação de Inscrição;</li>
            <li>Cumprir as demais determinações do Edital e da equipe de aplicação;</li>
            <li>Guardar todos os seus pertences, a Declaração de Comparecimento e o Cartão de Confirmação de Inscrição no envelope porta-objetos antes de entrar na sala de provas.</li>
          </ul>
        </div>
      </section>
      
      <p className='document-rules'>É obrigatória a apresentação de documento de identificação original com foto para a realização da prova. Não serão aceitos documentos impressos ou digitais sem foto.</p>

      <footer className="footer">
        <div className='footer-images'>

          <div className='footer-rv-img'><img src={logoColorSrc} alt="Logo" /></div>

          <div className='enem-titulo-container'> 
            <div className='enem-simulado'>SIMULADO</div>
            <div className="enem-titulo"><span className='enem-titulo-bold'>enem</span><span className='enem-year'>2026</span></div>
          </div>

        </div>
        
        <button className="exam details confirmacao" onClick={handlePrint}>Imprimir</button>
      </footer>
    </div>

      </div>
    </div>
  );
}

export default LocalDeProva;
